/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export function hasValue(value: any): boolean {
  return value !== undefined && value !== null;
}
